import day from 'dayjs'

export const getStringDate = (timestamp: number | string) =>
    (typeof timestamp === 'number' ? day.unix(timestamp) : day(timestamp)).format('MMM. DD, YYYY')
